import { render, staticRenderFns } from "./adv-mobile-sticky-rsya-body.component.vue?vue&type=template&id=01674f7c&"
import script from "./adv-mobile-sticky-rsya-body.component.vue?vue&type=script&lang=ts&"
export * from "./adv-mobile-sticky-rsya-body.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports